import { VIDEO_MIME_TYPES } from '@crehana/player';

export const trailerTypeToMimeType = (videoSourceType: string) =>
  videoSourceType.toUpperCase().includes('HLS')
    ? VIDEO_MIME_TYPES.HLS
    : VIDEO_MIME_TYPES.MP4;
